import axios from "axios";
import {
    IP
} from "./config";
// // 生成卡密列表
// export async function createCardnumberList(num, supplierPhone) {
//     var resp = await axios.post(`${IP}/vipcard/createCardnumber`, {
//         num,
//         supplierPhone
//     });
//     return resp;
// }
// // 查询会员卡 类型：0只查卡密 1支付的会员 2卡密的会员 3查1和2  phone:用户手机号
// export async function selectCardnumberList(cardType, supplierPhone, phone, cardNumber) {
//     var resp = await axios.post(`${IP}/vipcard/selectCardpassword`, {
//         // total: 8,
//         // pageSize,
//         cardType,
//         supplierPhone,
//         phone,
//         cardNumber
//     });
//     return resp.data;
// }
//绑定卡密
// export async function setVipcardByuserid(userId, cardNumber) {
//     var resp = await axios.post(`${IP}/vipcard/setuserid`, {
//         userId,
//         cardNumber
//     });
//     return resp;
// }

//查询 分享记录
export async function seleteshareByid() {
    var resp = await axios.post(`${IP}/share/select`, {
    });
    return resp.data;
}
//  根据用户id 分享者id 订单号查分享记录
export async function seleteshareByName(userId,shareUserId,orderNumber) {
    var resp = await axios.post(`${IP}/share/selectByName`, {
        userId,shareUserId,orderNumber
    });
    return resp.data;
}

// 删除分享记录
export async function deleteShare(id) {
    var resp = await axios.post(`${IP}/share/delete`, {
        id
    });
    return resp.data;
}

//查询 提现记录
export async function selectmoneyrecord() {
    var resp = await axios.post(`${IP}/money/selectMoney`, {

    });
    return resp.data;
}

//查询 修改提现状态
export async function updatestatus(id, cashStatus) {
    var resp = await axios.post(`${IP}/money/updateMoney`, {
        id,
        cashStatus
    });
    return resp;
}

// //查询 所有支付的类型及价钱
// export async function selectpaylist() {
//     var resp = await axios.post(`${IP}/role/selectpaylist`, {});
//     return resp;
// }

// //修改 所有支付的类型及价钱
// export async function uodatepaybyid(id, money) {
//     var resp = await axios.post(`${IP}/role/uodatepaybyid`, {
//         id,
//         money
//     });
//     return resp;
// }